// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"bdde28cb","363":"617b703e","453":"81b78c0a","827":"a85662e3"}[chunkId] + ".chunk.js";
};